module.exports = __webpack_public_path__ + "img/pdf.f1c671c2.svg";